import { useMemo } from 'react'
import { TrunkingSite } from '../../app/types'
import { SectionedForm } from '../../common/components/SectionedForm'
import { usePrivilege } from '../../common/util/hooks'
import { FeaturePrivileges } from '../../common/util/featurePrivileges'
import { useGeneralSection } from '../general'
import { useSoiPeeringConfigSection } from './soiPeeringConfig'
import { useSoiPeeringNumberFormattingSection } from './soiPeeringNumberFormatting'
import { useSoiPeeringWanSection } from './soiPeeringWan'

export const SoiPeeringDetail = (isFetching: boolean, error: any, refetch: () => void, data?: TrunkingSite) => {

    const { hasAccess: hasWriteAccess } = usePrivilege(FeaturePrivileges.trunkSite.write)

    const generalSection = useGeneralSection(isFetching, error, refetch, data);
    const soiPeeringConfigSection = useSoiPeeringConfigSection(data);
    const soiPeeringNumberFormattingSection = useSoiPeeringNumberFormattingSection(data);
    const soiPeeringWanSection = useSoiPeeringWanSection(data);
    const formSections = useMemo(() => [
        generalSection, soiPeeringConfigSection, soiPeeringNumberFormattingSection, soiPeeringWanSection
    ], [generalSection, soiPeeringConfigSection, soiPeeringWanSection, soiPeeringNumberFormattingSection])

    return <SectionedForm formSections={formSections} activeTab={0} readOnly={!hasWriteAccess}/>
}
